export default __webpack_public_path__ + "static/Group 83-c99f25f967ee844afdab19675332439e.jpg";